import "../../pages/new/new.scss"

import React, { useState,useEffect } from 'react';
import { useNavigate , useParams } from 'react-router-dom';
import { Container, TextField, Button, Box } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import { getStudentById,getStudentCourses} from '../../services/studentService';
import {AddInstructor} from './AddInstructor';
import {UndertakingCourse} from './UndertakingCourse';
import {ThesisMentor} from './ThesisMentor';
import InstructorPerformance from './InstructorPerformance';
import {MentorStudentList} from '../datatable/MentorStudentList';

export const InstructorView = () => {
    const navigate = useNavigate();
    const { instructorId } = useParams(); 
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const goBack = (e) => {
        navigate('/instructors');
    };

    return (
        <div>
        
        <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Instructor Info" />
            {instructorId!=undefined && <Tab label="Performance Summary" /> }
            {instructorId!=undefined && <Tab label="Students Under Guidance" /> }
        </Tabs>
        {activeTab === 0 && <AddInstructor />}
        {activeTab === 1 && <InstructorPerformance instructorId={instructorId}/>}
        {activeTab === 2 && <MentorStudentList instructorId={instructorId}/>}
        
        {activeTab != 0 && <button onClick={goBack}>Back</button>}
        {/*<button >Submit</button>*/}
    </div>
      );
}